import { render, staticRenderFns } from "./PartnerGeneralData.vue?vue&type=template&id=204dc243"
import script from "./PartnerGeneralData.vue?vue&type=script&lang=js"
export * from "./PartnerGeneralData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports